import React from 'react';
import styled from 'styled-components';
import logoB from '../../assets/images/logoB.svg';

const Container = styled.div`
  margin-bottom: 50px;

  @media (max-width: 768px) {
    position: absolute;
    top: 50px;
  }
`;

const Title = styled.p`
  font-size: 18px;
  margin-top: 20px;
  text-align: center;
  color: ${({ theme }) => theme.colors.textColor};
`;

interface AuthLogoProps {
  title?: string; // title을 선택적으로 받을 수 있도록 설정
}

const AuthLogo: React.FC<AuthLogoProps> = ({ title }) => {
  return (
    <Container>
      <img src={logoB} alt="Logo" />
      {title && <Title>{title}</Title>} {/* title이 존재할 때만 표시 */}
    </Container>
  );
};

export default AuthLogo;
